import { render, staticRenderFns } from "./english-small-report.vue?vue&type=template&id=16069535&scoped=true&"
import script from "./english-small-report.vue?vue&type=script&lang=js&"
export * from "./english-small-report.vue?vue&type=script&lang=js&"
import style0 from "./english-small-report.vue?vue&type=style&index=0&id=16069535&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16069535",
  null
  
)

export default component.exports